import React, { useEffect } from "react"

import { useContent } from "../../context/contentProvider"

import "./index.css"
import { XIcon } from "../Icons"

const Modal = () => {
    const { isModal, setModal, modalContent } = useContent();

    useEffect(() => {
        if (isModal) {
          document.documentElement.classList.add("html--menu-open");
        } else {
          document.documentElement.classList.remove("html--menu-open");
        }

        return () => {
          document.documentElement.classList.remove("html--menu-open");
        };
      }, [isModal]);

    return (
        <div className="component-modal">
            {isModal && (
                <div className="relative modal-inner-content">
                    <div className="modal--content">
                        <div className="modal--content-inner" style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            zIndex: 21
                        }}>
                            <div style={{ position: 'fixed', top: 0, left: 0, zIndex: 20, width: '100%', height: '100%',background: 'rgba(0, 0, 0, 0.5)' }} onClick={() => setModal(false)}></div>
                            <div style={{
                                position: 'absolute',
                                left: '50%',
                                zIndex: 22,
                                transform: 'translateX(-50%)'
                            }}>
                                <button
                                    style={{
                                        position: 'absolute',
                                        top: 10,
                                        right: 10,
                                        zIndex: 23,
                                        margin: 0,
                                        padding: 0,
                                        cursor: 'pointer',
                                        backgroundColor: '#F5333F',
                                        border: 0,
                                        borderRadius: '5px'
                                    }}
                                    onClick={() => setModal(false)}
                                >
                                    <XIcon color={'#fff'} />
                                </button>
                                {modalContent}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Modal